// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__pWxZc","header":"styles_header__0ik_M","upperTitle":"styles_upperTitle__RQWz5","basicTitle":"styles_basicTitle__5rvlm","iframe":"styles_iframe__dnGYb"};